import { useEffect } from 'react';
import './cv.css';

function CVPage() {
  useEffect(() => {
    document.body.classList.add('cv-page');
    return () => {
      document.body.classList.remove('cv-page');
    };
  }, []);

  return (
    <div className="cv-container">

      {/* PROFILE */}
      <div className="cv-profile">
        <div className="cv-prompt-line">
          <span className="cv-prompt-symbol">❯</span>
          cat ./loubna-bouzenzen.md
          <span className="cv-cursor" />
        </div>
        <h1>Loubna <span className="highlight">Bouzenzen</span></h1>
        <p className="cv-location">Algeria · +213 657 64 02 61</p>
        <p>
          <a href="mailto:loubnabouzenzen@outlook.com">loubnabouzenzen@outlook.com</a>
        </p>
        <p className="cv-links">
          <a href="https://www.linkedin.com/in/loubna-bouzenzen-86a6441b8/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          <span className="cv-dot">·</span>
          <a href="https://github.com/Elby2112" target="_blank" rel="noopener noreferrer">GitHub</a>
        </p>
      </div>

      {/* EDUCATION */}
      <section className="cv-section">
        <h2><span className="cv-section-tag">{'// '}</span>Education</h2>
        <ul>
          <li>
            <strong>Badji Mokhtar - Annaba University (UBMA)</strong><br />
            MS in Computer Science / Big Data Management and Analysis<br />
            <em>Graduation: July 2024</em><br />
            Relevant Courses: Machine Learning, Data Science & Analytics, Data Mining, Optimization.
          </li>
          <li>
            <strong>Badji Mokhtar - Annaba University (UBMA)</strong><br />
            BS in Computer Science / Information Systems<br />
            <em>Graduation: July 2022</em><br />
            Relevant Courses: Computer Science, Mathematics, Mobile & Web Development, Linear Programming, Cyber Security.
          </li>
        </ul>
      </section>

      {/* MSC THESIS */}
      <section className="cv-section">
        <h2><span className="cv-section-tag">{'// '}</span>MSc Thesis</h2>
        <p><strong>Theme:</strong> Optimization of Water Distribution Networks</p>
        <ul>
          <li>Focused on optimizing the pipe diameter parameter in water distribution networks.</li>
          <li>Implemented two approaches: a deterministic method (Sequential Quadratic Programming) and a metaheuristic method (Genetic Algorithm) for comparative analysis.</li>
          <li>Algorithms implemented in Java and integrated with Flowmax hydraulic network simulation software for testing on real network models.</li>
        </ul>
      </section>

      {/* WORK EXPERIENCE */}
      <section className="cv-section">
        <h2><span className="cv-section-tag">{'// '}</span>Work Experience</h2>

        <div className="cv-job">
          <p className="cv-job-title"><strong>Wajeez - Algeria</strong></p>
          <p className="cv-job-meta">Software Developer (Full-time) · Nov 2025 – Present</p>
          <ul>
            <li>Frontend mobile development using Flutter.</li>
          </ul>
        </div>

        <div className="cv-job">
          <p className="cv-job-title"><strong>ProcessTool - Algeria</strong></p>
          <p className="cv-job-meta">Software Engineer (Part-time) · Jan 2024 – Jul 2025</p>
          <ul>
            <li>Developed specialized Java-based tools that streamlined engineering calculations for the oil & gas sector.</li>
            <li>Designed and deployed the company website to strengthen digital presence and client outreach.</li>
          </ul>
        </div>

        <div className="cv-job">
          <p className="cv-job-title"><strong>Nahla Delivery - Algeria</strong></p>
          <p className="cv-job-meta">UX/UI Designer & Flutter Developer Intern · Feb 2022 – Jun 2022</p>
          <ul>
            <li>Enhanced a grocery delivery app in Flutter by improving functionality and navigation based on user research.</li>
          </ul>
        </div>
      </section>

      {/* AWARDS / PROJECTS */}
      <section className="cv-section">
        <h2><span className="cv-section-tag">{'// '}</span>Awards & Projects</h2>

        <div className="cv-job">
          <p className="cv-job-title">
            <strong>Google Women Techmakers Hackathon – Winner</strong>
            <span className="cv-award-badge">🏆 Winner</span>
          </p>
          <p className="cv-job-meta">Salary Negotiation Assistant – Prospera · Oct 2024 – Dec 2024</p>
          <ul>
            <li>AI-powered web app using Golang + React to generate salary benchmarks and tailored negotiation scripts via Gemini API.</li>
            <li>Integrated external salary datasets and optimized UI/UX for usability.</li>
          </ul>
        </div>

        <div className="cv-job">
          <p className="cv-job-title"><strong>ProcessTool Project</strong></p>
          <p className="cv-job-meta">Optimization of Water Distribution Network · Feb 2024 – Jun 2024</p>
          <ul>
            <li>Built optimization models using Genetic Algorithms and SQP integrated with Flowmax.</li>
            <li>Implemented algorithms in Java with AI-driven optimization techniques.</li>
          </ul>
        </div>
      </section>

      {/* SKILLS */}
      <section className="cv-section">
        <h2><span className="cv-section-tag">{'// '}</span>Skills & Interests</h2>
        <div className="cv-skills">
          <span>Java</span><span>Python</span><span>C</span><span>Flutter</span>
          <span>Firebase</span><span>HTML</span><span>CSS</span><span>React.js</span>
          <span>Pandas</span><span>NumPy</span><span>Scikit-Learn</span><span>Matplotlib</span>
          <span>R</span><span>Gurobi</span><span>CPLEX</span><span>Statistics</span>
          <span>Git</span><span>Figma</span><span>Microsoft Office</span>
          <span>Arabic</span><span>English</span><span>French</span>
          <span>Optimization (Stochastic, Evolutionary, Combinatorial)</span>
        </div>
        <p className="cv-interests">
          Interests: Research in AI & Optimization · Hackathons · Writing & Blogging · Public Speaking
        </p>
      </section>

      {/* CERTIFICATIONS */}
      <section className="cv-section">
        <h2><span className="cv-section-tag">{'// '}</span>Certifications</h2>
        <ul>
          <li>Amadeus Program Certification · 2024</li>
        </ul>
      </section>

    </div>
  );
}

export default CVPage;